import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { AppAvatarInitialsPipe } from './avatar-initials.pipe';
import { AvatarColor, AvatarSize, AvatarType } from './types';

@Component({
  selector: 'app-avatar',
  standalone: true,
  imports: [CommonModule, MatIconModule, AppAvatarInitialsPipe],
  templateUrl: './avatar.component.html',
  styleUrl: './avatar.component.scss',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppAvatarComponent {
  @Input() color: AvatarColor = 'standard';
  @Input() imageUrl = '';
  @Input() name = '';
  @Input() size: AvatarSize = 'xs';
  @Input() type: AvatarType = 'image';

  isTruncated = false;
}
